import { AttributesMixin, define, Model, type } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { NotificationSubscription } from "./notificationSubscription";

export interface NotificationSubscriptionPage extends AttributesMixin<typeof NotificationSubscriptionPage> { }
@define
export class NotificationSubscriptionPage extends Model {
    static endpoint = restfulIO('/api/v1/notificationSubscriptions/list');

    static attributes = {
        items: type([ NotificationSubscription ]).endpoint(restfulIO('./')).dontSave,
        count: Number
    }
}
